import { createFeatureSelector, createSelector } from "@ngrx/store";
import { featureKey, UserState } from "./user.reducers";

const featureSelector = createFeatureSelector<UserState>(featureKey);

export const currentUser = createSelector(featureSelector, state => state.currentUser);
export const respondUser = createSelector(featureSelector, state => state.respondUser);
export const isEmulated = createSelector(featureSelector, state => !!state.originalUser);
export const permissions = createSelector(featureSelector, state => state.permissions);
export const currentUserFeatureIds = createSelector(featureSelector, state => state.currentUserFeatureIds || []);
